import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { TestTypeActions, TestTypeActionTypes } from './test-type.actions';
import { TestTypeEntity } from './test-type.model';

export type TestTypeEntities = EntityState<TestTypeEntity>;

export const adapter: EntityAdapter<TestTypeEntity> = createEntityAdapter<TestTypeEntity>();

export const initialState: TestTypeEntities = adapter.getInitialState({
  // additional entity state properties
});

export function reducer(state = initialState, incomingAction: Action): TestTypeEntities {
  const action = incomingAction as TestTypeActions;
  switch (action.type) {
    case TestTypeActionTypes.AddTestType: {
      return adapter.addOne(action.payload.testType, state);
    }

    case TestTypeActionTypes.UpsertTestType: {
      return adapter.upsertOne(action.payload.testType, state);
    }

    case TestTypeActionTypes.AddTestTypes: {
      return adapter.addMany(action.payload.testTypes, state);
    }

    case TestTypeActionTypes.UpsertTestTypes: {
      return adapter.upsertMany(action.payload.testTypes, state);
    }

    case TestTypeActionTypes.UpdateTestType: {
      return adapter.updateOne(action.payload.testType, state);
    }

    case TestTypeActionTypes.UpdateTestTypes: {
      return adapter.updateMany(action.payload.testTypes, state);
    }

    case TestTypeActionTypes.DeleteTestType: {
      return adapter.removeOne(action.payload.id, state);
    }

    case TestTypeActionTypes.DeleteTestTypes: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case TestTypeActionTypes.LoadTestTypes: {
      return adapter.setAll(action.payload.testTypes, state);
    }

    case TestTypeActionTypes.ClearTestTypes: {
      return adapter.removeAll(state);
    }

    default: {
      return state;
    }
  }
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
